
































































import { Component, Vue } from 'vue-property-decorator'
import gzhManager from '@/views/gzhManager.vue'
import { Api } from '@/service/api'
import Qs from 'qs'

@Component({
  components: {
    gzhManager
  }
})
export default class Entry extends Vue {

  private app_id = ''
  private loading: any = false
  private menu_list: any = null
  private gzh_info: any = null

  private mounted () {
    const search = location.search.replace(/^\?/, '')
    const params = Qs.parse(search)
    this.app_id = params.app_id as string
    this.gzhMenuList()
    this.getGzhInfo()
  }

  private async getGzhInfo () {
    const res: any = await Api.getGzhInfo(this.app_id)
    if (res.code === 0) {
      console.info(res.data)
      this.gzh_info = res.data
    }
  }

  // 拉取公众号菜单
  private async pullGzhMenu () {
    const res: any = await Api.pullGzhMenu(this.app_id)
    if (res.code === 0) {
      this.menu_list = res.data
      await this.gzhMenuList()
    }
  }

  // 加载数据
  private async gzhMenuList () {
    this.loading = true
    const res: any = await Api.gzhMenuList(this.app_id)
    this.menu_list = res.data

    this.loading = false
  }

  private toMenuEdit (menu: any) {
    this.$router.push({
      path: '/gzh-menu-edit',
      query: {
        gzh_menu_id: menu.id,
        app_id: this.app_id
      }
    })
  }

  private backGzhEntry () {
    location.href = '/gzh_entry'
  }

  private async createNewMenu () {
    const res: any = await Api.createGzhMenu(this.app_id)
    if (res.code === 0) {
      this.$router.push({
        path: '/gzh-menu-edit',
        query: {
          gzh_menu_id: res.data.id,
          app_id: this.app_id
        }
      })
    }
  }

  // 复制一条数据
  private async copyMenu (menu: any) {
    const res: any = await Api.copyGzhMenu(this.app_id, menu.id)
    await this.gzhMenuList()
  }

  // 发布并修改状态
  private async publishMenu (menu: any) {
    this.loading = true

    const res: any = await Api.publishGzhMenu(this.app_id, menu.id)

    if (res.code === 0) {
      this.$message.info('发布成功')
      await this.gzhMenuList()
    } else {
      this.$message.error(res.errmsg)
      this.loading = false
    }
  }

  // 删除菜单
  private async deleteMenu (menu: any) {

    this.loading = true

    const res: any = await Api.deleteGzhMenu(this.app_id, menu.id)

    if (res.code === 0) {
      await this.gzhMenuList()
    } else {
      this.$message.error(res.errmsg)
      this.loading = false
    }
  }
}
